<template>
	<div class="pointManage">

		<div class="breadcrumb" style="font-size: 14px;">点位管理
			<el-upload class="uploadBtn_pM right_f" :with-credentials='true' v-show="isselectcampus" :action="importurl1"
				:on-success="chenggong" :on-error="shibai" :auto-upload="true" name="uploadFile">
				<el-button type="primary">导入点位</el-button>
			</el-upload>
			<el-button v-show="pointData.length > 0" class="right_f" type="primary" @click="exportpoints">导出点位
			</el-button>
			<el-button v-show="pointData.length > 0" class="right_f" type="primary" @click="setNecessaryPoint">设置必经点
			</el-button>
			<el-button v-show="region > 0" class="right_f" type="primary" @click="setRunningFence">设置围栏</el-button>
			<el-button v-show="pointData.length > 0" class="right_f" type="primary" @click="jumpRunareaPage">跑区管理
			</el-button>
		</div>

		<div class="selectSchool">
			<el-select style="width:100%" @visible-change="handleChange" id="selectInput" class="selectInput"
				v-model="region" filterable clearable placeholder="请输入高校名称" @change="getPoints">
				<el-option v-for="item in option" :key="item.unid" :label="item.name" :value="item.unid"></el-option>
			</el-select>
		</div>

		<div class="warning" style="font-size: 14px; margin-left: 20px;">
			<p>请先选择一个校区，再进行点位导入和导出操作</p>
			<p>提示：请导入完整的点位列表！设置点位信息后，之前的点位信息不会被保留！</p>
		</div>

		<div class="com-list">
			<el-table v-show="pointData.length > 0" :data="pointData" style="width: 100%">
				<el-table-column type="index" prop="index" label="序号" width="100px"></el-table-column>
				<el-table-column prop="pointsNumber" label="点位编号"></el-table-column>
				<el-table-column prop="pointsDesc" label="点位名称"></el-table-column>
				<el-table-column prop="lon" label="经度"></el-table-column>
				<el-table-column prop="lat" label="纬度"></el-table-column>
				<el-table-column prop="relatedPoints" label="关联点位"></el-table-column>
				<el-table-column prop="mustThoughPoint" label="必经点位"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			region: '',
			option: [],
			pointData: [],
			isselectcampus: false,
			importurl: '/adminapi/v1/campus/points/importPointsInfo?unid=',
			unid: ''
		}
	},
	mounted() {
		this.getallcampus();
		const unid = this.$util.getUrlParam("unid") * 1;
		this.region = unid || ''
		if (this.region) {
			this.getPoints();
		}
	},
	computed: {
		importurl1() {
			return this.$util.domain + this.importurl + this.unid;
		}
	},
	methods: {
		//获取所有校区
		getallcampus() {
			this.$http({
				method: 'get',
				url: this.$util.domain + '/adminapi/v1/basicTools/allCampusZones'
			}).then((response) => {
				if (response.data.error == 10000) {
					this.option = response.data.data;
					// this.region = this.$util.getUrlParam("unid");
				} else {
					this.$util.errorMsg(response.data.message);
				}
			})
		},
		//根据校区获取点位
		getPoints() {
			if (!this.region) return
			this.isselectcampus = true;
			this.$http({
				method: 'GET',
				url: this.$util.domain + '/adminapi/v1/campus/points/queryPointsInfo',
				params: {
					unid: this.region
				}
			}).then(response => {
				if (response.data.error == 10000) {
					response.data.data.forEach(item => {
						item.mustThoughPoint = (item.mustThoughPoint) ? "是" : "否";
					});
					this.pointData = response.data.data;
					this.unid = this.region;
				} else {
					this.$util.errorMsg('获取该校区点位失败');
				}
			})
		},
		//导出点位
		exportpoints() {
			if (this.region) {
				location.href = this.$util.domain + '/adminapi/v1/campus/points/exportPointsInfo?unid=' + this.region;
			} else {
				this.$util.errorMsg('发生未知错误');
			}

		},
		//导入成功
		chenggong(response) {
			if (response.error == 10000) {
				this.$util.successMsg('导入点位成功');
			} else {
				this.$util.errorMsg(`${response.message},${response.data}`);
			}
		},
		shibai(response) {
			this.$util.errorMsg("未知错误，请重试");
		},
		//设置必经点
		setNecessaryPoint() {
			location.href = `/#/xiaoyuan/GX/setMustPoint?unid=${this.region}`;
		},
		// 设置围栏
		setRunningFence() {
			location.href = `/#/xiaoyuan/GX/runningFence?unid=${this.region}`;
		},
		//聚焦
		handleChange(e) {
			if (e) {
				const temp = this.region
				this.region = ''
				this.$nextTick(() => this.region = temp)
			}

		},
		jumpRunareaPage() {
			this.$router.push({
				path: '/xiaoyuan/GX/runarea',
				query: {
					unid: this.region
				}
			})
		}
	}
}
</script>
<style>
.pointManage {
	min-height: 120vh;
}

.uploadBtn_pM {
	display: inline-block;
	width: 90px;
	text-indent: 0;
}

.downLoadBtn_pM {
	position: absolute;
	right: 120px;
	display: inline-block;
}

.setNecessaryPoint {
	position: absolute;
	right: 220px;
}

.el-upload__files {
	display: none;
}
</style>


// WEBPACK FOOTER //
// pointManage.vue?5f4faf35